import {
  hausbankFields,
  hausbankFieldsWithSectionString,
  PurposeOptions,
} from 'hausbank/inquiry/fields';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import { fieldValidators } from 'modules/Inquiry/inquiryFieldValidation/customValidations';
import { validateFieldValidationMap, ValidateSectionFunction } from 'new/form/useValidateFields';

export const validatePurposeSection: ValidateSectionFunction<InquiryType.hausbank> = (
  form,
  values,
  store,
  conditions,
) => {
  return validateFieldValidationMap({
    validationMap: purposeSectionValidationMap,
    form,
    values,
    conditions,
  });
};

const { projectDescription } = hausbankFields.financingNeedPage.purposeSection;
const { sectionString: purposeKind } =
  hausbankFieldsWithSectionString.financingNeedPage.purposeSection.purposeKind;

export const purposeSectionValidationMap = {
  [purposeKind]: fieldValidators.minLength().select(1),
  [projectDescription]: (_value: string | undefined, values: any) => {
    const purposes = values?.financingNeedPage?.purposeSection?.purposeKind ?? [];
    const isOtherSelected =
      Array.isArray(purposes) && purposes.some((p) => p?.id === PurposeOptions.other);

    const schema = fieldValidators.string().max(2000);
    return isOtherSelected ? schema.required() : schema;
  },
};
